const ExperienceData = [
  {
    title: "Full Stack Developer Intern",
    company: "Atoms Digital Solutions",
    duration: "March 2023 - Feb 2024",
    description: [
      "Engineered Vaaradhi Portal, a management website for underprivileged students and orphans with educational facilities.",
      "Collaborated with a team of 4 developers to ensure seamless integration of the application.",
      "Implemented the MERN stack (MongoDB, Express.js, React.js, Node.js) with Google Cloud resulting in a 30% reduction in image loading.",
      "Streamlined data entry and paperwork processes with the website, saving approximately 20 hours per week.",
    ],
  },
  {
    title: "Frontend Developer Intern",
    company: "BabyCloud",
    duration: "July 2024 - Present",
    description: [
      "Oversees the BabyCloud website, optimizing performance and delivering a seamless user experience.",
      "Incorporated analytics for user engagement insights and ads to drive website traffic.",
      "Implemented the Baby Name Generator feature, significantly boosting organic search rankings.",
      "Integrated Razorpay for secure payments, enabling seamless Child Development Program plan purchases.",
    ],
  },
];

export default ExperienceData;
